import { styled } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';

export const NumberedFormWrapper = styled(Grid)(({ theme }) => ({
  paddingLeft: theme.spacing(1.5)
}));
